/* Spare product page extras: "How many do I need?" planner, "Need it urgently?" panel,
   "Who is this for?" names (saved on this device), shelf-count age, price history. */
(function () {
  function money(cents) {
    return '$' + (cents / 100).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }
  const DAY = 864e5;
  function parseDate(v) { if (!/^\d{4}-\d{2}-\d{2}$/.test(v || '')) return null; const p = v.split('-'); return Date.UTC(+p[0], +p[1] - 1, +p[2]); }
  function todayUTC() {
    const f = new Intl.DateTimeFormat('en-CA', { timeZone: 'America/New_York', year: 'numeric', month: '2-digit', day: '2-digit' }).format(new Date());
    return parseDate(f);
  }
  function iso(t) { return new Date(t).toISOString().slice(0, 10); }
  function nice(t) {
    const sameYear = new Date(t).getUTCFullYear() === new Date(todayUTC()).getUTCFullYear();
    return new Date(t).toLocaleDateString('en-US', sameYear ? { timeZone: 'UTC', month: 'short', day: 'numeric' } : { timeZone: 'UTC', month: 'short', day: 'numeric', year: 'numeric' });
  }
  const store = {
    get(k, d) { try { const v = JSON.parse(localStorage.getItem(k)); return v == null ? d : v; } catch (e) { return d; } },
    set(k, v) { try { localStorage.setItem(k, JSON.stringify(v)); } catch (e) {} }
  };

  // Cheapest way to buy exactly n units (or the fewest extra) from the packs on the shelf.
  function bestCombo(cands, n) {
    if (n <= 0 || !cands.length) return null;
    const maxU = Math.max.apply(null, cands.map((c) => c.units));
    const limit = n + maxU;
    const INF = Infinity;
    let best = [{ cost: 0, n: 0, pick: {} }];
    for (let t = 1; t <= limit; t++) best[t] = { cost: INF, n: INF, pick: null };
    // bounded knapsack by expanding each pack into single items (quantities stay small)
    cands.forEach((c) => {
      const maxCount = Math.min(c.max, Math.ceil(limit / c.units));
      for (let k = 0; k < maxCount; k++) {
        for (let t = limit; t >= c.units; t--) {
          const prev = best[t - c.units];
          if (prev.cost === INF) continue;
          const used = (prev.pick[c.id] || 0);
          if (used >= c.max) continue;
          const cost = prev.cost + c.price;
          if (cost < best[t].cost || (cost === best[t].cost && prev.n + 1 < best[t].n)) {
            const pick = Object.assign({}, prev.pick); pick[c.id] = used + 1;
            best[t] = { cost: cost, n: prev.n + 1, pick: pick };
          }
        }
      }
    });
    for (let t = n; t <= limit; t++) if (best[t].cost !== INF) return { units: t, cost: best[t].cost, pick: best[t].pick };
    return null;
  }

  function init(root) {
    const dataEl = root.querySelector('[data-spare-variants]');
    if (!dataEl) return;
    const variants = JSON.parse(dataEl.textContent);
    const unit = root.dataset.unit || 'unit';
    const wear = parseInt(root.dataset.wearDays || '0', 10);
    const plural = (n) => (n === 1 ? unit : unit + 's');
    const idInput = root.querySelector('[data-spare-variant-input]');
    const base = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    const isDamaged = (v) => v.options.some((o) => /damaged/i.test(o));
    const current = () => variants.find((v) => String(v.id) === idInput.value) || variants[0];

    /* ---------- Need it urgently? ---------- */
    const fastBtn = root.querySelector('[data-spare-fast-toggle]');
    const fast = root.querySelector('[data-spare-fast]');
    if (fastBtn && fast) {
      fastBtn.addEventListener('click', () => {
        const open = fast.hidden;
        fast.hidden = !open;
        fastBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    }

    /* ---------- Planner ---------- */
    const plan = root.querySelector('[data-spare-plan]');
    let lastCombo = null;
    function setTab(name) {
      if (!plan) return;
      plan.querySelectorAll('[data-plan-tab]').forEach((b) => b.setAttribute('aria-selected', b.dataset.planTab === name ? 'true' : 'false'));
      plan.querySelectorAll('[data-plan-pane]').forEach((p) => { p.hidden = p.dataset.planPane !== name; });
      plan.dataset.tab = name;
      compute();
    }
    function compute() {
      if (!plan) return;
      const out = plan.querySelector('[data-plan-out]');
      const add = plan.querySelector('[data-plan-add]');
      add.hidden = true; lastCombo = null;
      const tab = plan.dataset.tab || 'refill';
      const q = (sel) => plan.querySelector(sel);
      let need = 0, extra = 0, lead = '';
      if (tab === 'refill') {
        const end = parseDate(q('[data-plan-end]').value) || todayUTC();
        const refill = parseDate(q('[data-plan-refill]').value);
        if (!refill) { out.textContent = 'Pick your refill date and we’ll work out the gap.'; return; }
        const gap = Math.round((refill - end) / DAY);
        if (gap <= 0) { out.textContent = 'Your current ' + unit + ' lasts until your refill date. You don’t need to buy any.'; return; }
        need = Math.ceil(gap / wear);
        extra = q('[data-plan-refill-spare]').checked ? 1 : 0;
        lead = 'Gap: ' + gap + ' days (' + nice(end) + ' to ' + nice(refill) + '). ' + need + ' ' + plural(need) + (need === 1 ? ' covers ' : ' cover ') + need * wear + ' days';
      } else {
        const leave = parseDate(q('[data-plan-leave]').value);
        const back = parseDate(q('[data-plan-back]').value);
        const end = parseDate(q('[data-plan-trip-end]').value);
        if (!leave || !back) { out.textContent = 'Pick the days you leave and come back.'; return; }
        if (back < leave) { out.textContent = 'Your return date is before you leave. Check the dates.'; return; }
        const start = end && end > leave ? end : leave;
        const days = end && end > leave ? Math.round((back - start) / DAY) : Math.round((back - leave) / DAY) + 1;
        extra = parseInt(q('[data-plan-margin]').value, 10) || 0;
        need = days > 0 ? Math.ceil(days / wear) : 0;
        lead = need ? 'You’re away ' + (Math.round((back - leave) / DAY) + 1) + ' days. ' + need + ' ' + plural(need) + (need === 1 ? ' covers' : ' cover') + ' the part your current one doesn’t' : 'Your current ' + unit + ' lasts the whole trip';
        lead += '. Order so it arrives before ' + nice(leave);
      }
      const total = need + extra;
      if (total <= 0) { out.textContent = lead + '.'; return; }
      const cur = current();
      const cands = variants.filter((v) => v.available && v.price > 0 && isDamaged(v) === isDamaged(cur))
        .map((v) => ({ id: v.id, units: v.units, price: v.price, title: (v.options.filter((o) => !/sealed|damaged/i.test(o)).join(' / ') || v.title) + (isDamaged(v) ? ' (damaged box)' : ''), max: v.managed ? Math.max(0, v.qty) : 99 }))
        .filter((c) => c.max > 0);
      const combo = bestCombo(cands, total);
      out.innerHTML = '';
      const h = document.createElement('strong');
      h.className = 'sp-save__year';
      h.textContent = 'You need ' + total + ' ' + plural(total) + (extra ? ' (' + need + ' + ' + extra + ' extra)' : '');
      const p = document.createElement('span');
      p.textContent = lead + '.';
      out.appendChild(h); out.appendChild(p);
      if (!combo) {
        const n = document.createElement('span');
        n.textContent = 'We don’t have that many on the shelf right now. Text us and we’ll tell you honestly what we can do.';
        out.appendChild(n);
        return;
      }
      const parts = Object.keys(combo.pick).map((id) => {
        const c = cands.find((x) => String(x.id) === String(id));
        return combo.pick[id] + ' × ' + (c.units > 1 ? c.units + '-' + unit + ' pack' : 'single ' + unit) + (/damaged/i.test(c.title) ? ' (damaged box)' : '');
      });
      const b = document.createElement('span');
      b.textContent = 'Cheapest way on our shelf: ' + parts.join(' + ') + ' = ' + money(combo.cost) + (combo.units > total ? ' (' + (combo.units - total) + ' more than you need, because packs don’t split)' : '') + '.';
      out.appendChild(b);
      lastCombo = combo;
      add.textContent = 'Add ' + combo.units + ' ' + plural(combo.units) + ' to cart · ' + money(combo.cost);
      add.hidden = false;
    }
    if (plan) {
      plan.querySelectorAll('[data-plan-tab]').forEach((b) => b.addEventListener('click', () => setTab(b.dataset.planTab)));
      plan.addEventListener('input', compute);
      plan.addEventListener('change', compute);
      const endInput = plan.querySelector('[data-plan-end]');
      if (endInput && !endInput.value) endInput.value = iso(todayUTC());
      root.querySelectorAll('[data-spare-plan-open]').forEach((b) => b.addEventListener('click', () => {
        setTab(b.dataset.spareplanOpen || b.getAttribute('data-spare-plan-open'));
        plan.scrollIntoView({ behavior: 'smooth', block: 'start' });
        const first = plan.querySelector('[data-plan-pane]:not([hidden]) input');
        if (first) setTimeout(() => first.focus({ preventScroll: true }), 400);
      }));
      root.querySelectorAll('[data-spare-option]').forEach((fs) => fs.addEventListener('change', () => setTimeout(compute, 0)));
      plan.querySelector('[data-plan-add]').addEventListener('click', (e) => {
        if (!lastCombo) return;
        const btn = e.currentTarget;
        const forInput = root.querySelector('[data-for-input]');
        const props = forInput && !forInput.disabled && forInput.value ? { For: forInput.value } : undefined;
        const items = Object.keys(lastCombo.pick).map((id) => ({ id: parseInt(id, 10), quantity: lastCombo.pick[id], properties: props }));
        btn.disabled = true;
        fetch(base + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: items }) })
          .then((r) => { if (!r.ok) throw new Error('add'); window.location.href = base + 'cart'; })
          .catch(() => { btn.disabled = false; btn.textContent = 'Couldn’t add that. Try again or text us.'; });
      });
      setTab('refill');
    }

    /* ---------- Who is this for? ---------- */
    const forBox = root.querySelector('[data-spare-for]');
    if (forBox) {
      const row = forBox.querySelector('[data-for-row]');
      const addBox = forBox.querySelector('[data-for-add]');
      const nameIn = forBox.querySelector('[data-for-name]');
      const hidden = forBox.querySelector('[data-for-input]');
      const title = (root.querySelector('.sp-title') || {}).textContent || '';
      let people = store.get('spare-people', []);
      if (!Array.isArray(people)) people = [];
      function choose(name) {
        hidden.value = name || '';
        hidden.disabled = !name;
        if (name) {
          people = people.map((p) => (p.name === name ? Object.assign({}, p, { title: title.trim(), url: window.location.pathname }) : p));
          store.set('spare-people', people);
        }
        draw();
      }
      function draw() {
        row.innerHTML = '';
        people.forEach((p) => {
          const wrap = document.createElement('span');
          wrap.className = 'sp-for__chip' + (hidden.value === p.name ? ' is-on' : '');
          const b = document.createElement('button');
          b.type = 'button';
          b.className = 'sp-for__pick';
          b.setAttribute('aria-pressed', hidden.value === p.name ? 'true' : 'false');
          b.textContent = p.name;
          b.addEventListener('click', () => choose(hidden.value === p.name ? '' : p.name));
          const x = document.createElement('button');
          x.type = 'button';
          x.className = 'sp-for__x';
          x.setAttribute('aria-label', 'Remove ' + p.name);
          x.textContent = '×';
          x.addEventListener('click', () => {
            people = people.filter((q) => q.name !== p.name);
            store.set('spare-people', people);
            if (hidden.value === p.name) { hidden.value = ''; hidden.disabled = true; }
            draw();
          });
          wrap.appendChild(b); wrap.appendChild(x);
          row.appendChild(wrap);
        });
        if (people.length < 6) {
          const plus = document.createElement('button');
          plus.type = 'button';
          plus.className = 'sp-for__plus';
          plus.textContent = people.length ? '+ Someone else' : '+ Add a name';
          plus.addEventListener('click', () => { addBox.hidden = false; nameIn.focus(); });
          row.appendChild(plus);
        }
      }
      function save() {
        const n = (nameIn.value || '').replace(/\s+/g, ' ').trim().slice(0, 24);
        if (!n) return;
        if (!people.some((p) => p.name.toLowerCase() === n.toLowerCase())) people.push({ name: n });
        store.set('spare-people', people);
        nameIn.value = ''; addBox.hidden = true;
        choose(people.find((p) => p.name.toLowerCase() === n.toLowerCase()).name);
      }
      forBox.querySelector('[data-for-save]').addEventListener('click', save);
      nameIn.addEventListener('keydown', (e) => { if (e.key === 'Enter') { e.preventDefault(); save(); } });
      forBox.hidden = false;
      draw();
    }

    /* ---------- Shelf count age ---------- */
    const counted = root.querySelector('[data-spare-counted]');
    if (counted) {
      const at = Date.parse(counted.dataset.at);
      if (!isNaN(at)) {
        const mins = Math.max(0, Math.round((Date.now() - at) / 6e4));
        let txt = mins < 60 ? mins + ' min' : (mins < 2880 ? Math.round(mins / 60) + ' hr' : Math.round(mins / 1440) + ' days');
        counted.textContent = ' · counted ' + (mins < 2 ? 'just now' : txt + ' ago');
      }
    }

    /* ---------- Price history ---------- */
    const hist = root.querySelector('[data-spare-history]');
    if (hist) {
      let pts = [];
      try { pts = JSON.parse(hist.querySelector('[data-hist-json]').textContent) || []; } catch (e) { pts = []; }
      pts = pts.map((x) => ({ t: parseDate(x.d), p: Math.round(parseFloat(x.p) * 100) })).filter((x) => x.t && x.p > 0).sort((a, b) => a.t - b.t);
      if (pts.length < 2) { hist.hidden = true; }
      else {
        const W = 320, H = 90, pad = 8;
        const t0 = pts[0].t, t1 = Math.max(todayUTC(), pts[pts.length - 1].t);
        const ps = pts.map((x) => x.p);
        const lo = Math.min.apply(null, ps), hi = Math.max.apply(null, ps);
        const X = (t) => pad + ((t - t0) / Math.max(1, t1 - t0)) * (W - pad * 2);
        const Y = (p) => hi === lo ? H / 2 : pad + (1 - (p - lo) / (hi - lo)) * (H - pad * 2);
        let d = '';
        pts.forEach((x, i) => { d += (i ? ' H' + X(x.t).toFixed(1) + ' V' : 'M' + X(x.t).toFixed(1) + ' ') + Y(x.p).toFixed(1); });
        d += ' H' + X(t1).toFixed(1);
        hist.querySelector('[data-hist-chart]').innerHTML =
          '<svg viewBox="0 0 ' + W + ' ' + H + '" width="100%" height="' + H + '" role="img" aria-label="Price over time"><path d="' + d + '" fill="none" stroke="#1E7466" stroke-width="2.5" stroke-linejoin="round"/></svg>';
        const now = pts[pts.length - 1];
        hist.querySelector('[data-hist-sum]').textContent =
          'Today ' + money(now.p) + ' per ' + unit + ' · lowest ' + money(lo) + ' · highest ' + money(hi) + ' · since ' + new Date(t0).toLocaleDateString('en-US', { timeZone: 'UTC', month: 'short', year: 'numeric' });
      }
    }
  }

  function boot() { document.querySelectorAll('[data-spare-product]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
